export default __webpack_public_path__ + "static/media/Group 7416.b854b9b7.png";